module.exports = __webpack_public_path__ + "img/bgc15.6fa081c4.png";